import { css, select } from "glamor";
import React, { useCallback, useState } from "react";
import { RiArrowDownSLine } from "react-icons/ri";
import {
  buttonColors,
  spacing,
  stateColors,
  typographyColors,
  uiColors,
} from "./theme";

const iconClass = css({
  marginRight: spacing.m,
});
const activeClass = css(
  {
    transition: ".3s all",
    color: `${typographyColors.defaultTitle} !important`,
  },
  select(`& .${iconClass}`, {
    transition: ".3s opacity",
    opacity: 1,
  })
);
const wrapper = css({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  padding: `${spacing.s} ${spacing.m}`,
  fontSize: 14,
  color: `${typographyColors.defaultBody} !important`,
  transition: ".3s all",
  height: 58,
  borderLeft: `8px solid transparent`,
  "&:hover": {
    ...activeClass,
  },
});
const disabledClass = css({
  color: stateColors.empty,
  pointerEvents: "none",
  userSelect: "none",
  "&:hover": {
    borderBottom: "none",
  },
  "&:visited": {
    borderBottom: "none",
    color: stateColors.empty,
  },
});
const wrapperClass = css({
  "> a": {
    backgroundColor: uiColors.backgroundLightest,
    paddingLeft: 64,
    border: "none",
    ":hover": {
      backgroundColor: uiColors.backgroundLightest,
      border: "none",
    },
  },
});
const arrowStyle = {
  marginLeft: "auto",
};

export default function AccordionMenu(props) {
  const { label, icon, active, disabled, children, className, ...rest } = props;
  const baseClass = css(
    wrapper,
    className && className,
    active && activeClass,
    disabled && disabledClass
  );
  const Icon = icon;
  const [open, setOpen] = useState(active);
  const toggleOpen = useCallback(
    (e) => {
      e.stopPropagation();
      setOpen(!open);
    },
    [open]
  );

  return (
    <div>
      <div className={baseClass} {...rest} onClick={toggleOpen}>
        {icon && <Icon size={14} className={iconClass} />}
        {label} <RiArrowDownSLine size={14} style={arrowStyle} />
      </div>

      {open && <div className={wrapperClass}>{children}</div>}
    </div>
  );
}
